import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Image, Button } from 'semantic-ui-react';
import Paper from '@material-ui/core/Paper';

class Combos extends React.Component {


    data() {
        let allParts = this.props.allParts;
        allParts = this.removeDuplicates(allParts);
        let combos = this.props.combos;
        let data = [];
        allParts.map((c) => {
            combos.map((v) => {
                if (v.combo_name == this.props.combo && v.partno == c.partno) {
                    c.units = v.units;
                    data.push(c);
                }
            })
        })
        return data;
    }

    removeDuplicates(originalArray) {
        var newArray = [];
        originalArray = originalArray.slice().reverse();
        var lookupObject  = {};
        for(var i in originalArray) {
           lookupObject[originalArray[i]['partno']] = originalArray[i];
        }
        for(i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    getSpareDetails(partno, item) {
        this.props.detailsSparesPage(partno, item);
    }

    addComboSet(data) {
        let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");
        if (!customerDualScreenorderList) {
            customerDualScreenorderList = "[]";
        }
        try {
            customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
            if (!customerDualScreenorderList) {
                customerDualScreenorderList = [];
            }
            let refId = 0;
            
            let item = {};


            data.map((c) => {
                let value = 0;
                item = c;
                customerDualScreenorderList.map((v) => {
                    if (v.partno == c.partno) {
                        value = 1;
                        v.qty = c.units;
                        v.quantity = c.units;
                        v.refId = refId++;
                    }
                })
                if (value == 0) {
                    customerDualScreenorderList.push({ 
                        'partno': item.partno, 'discountrs': 0,
                        'spare_name': item.title, 'partname': item.title, 'discountper': 0, 'point': 0, 'ava_stocks': 0, 
                        'qty': item.units, 'refId': refId++, 'brand': 1, 'remarks': 'remarks',
                        'tax': item.tax, 'discount': 0, 'quantity': item.units, checked: false,
                        'billtype': 'Invoice', 'mrp': item.mrp, 'uprice': item.mrp, 
                    })
                }
            })
            customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
            localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
            this.props.refreshData();
            this.setState({ customerDualScreenorderList })
        } catch (error) {
        }
    }

    addItem(item) {
        let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");
        if (!customerDualScreenorderList) {
            customerDualScreenorderList = "[]";
        }
        try {
            customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
            if (!customerDualScreenorderList) {
                customerDualScreenorderList = [];
            }
            let refId = 0;
            let value = 0;
            customerDualScreenorderList.map((v) => {
                if (v.partno == item.partno) {
                    value = 1;
                    v.qty = v.qty + 1;
                    v.quantity = v.quantity + 1;
                }
                else { 
                    refId = v.refId;
                }
            })
            refId = refId + 1;
            if (value == 0) {
                customerDualScreenorderList.push({ 
                    'partno': item.partno, 'discountrs': 0,
                    'spare_name': item.title, 'partname': item.title, 'discountper': 0, 'point': 0, 'ava_stocks': 0, 
                    'qty': item.units, 'refId': refId, 'brand': 1, 'remarks': 'remarks',
                    'tax': item.tax, 'discount': 0, 'quantity': item.units, checked: false,
                    'billtype': 'Invoice', 'mrp': item.mrp, 'uprice': item.mrp, 
                })
            }
            customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
            localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
            this.props.refreshData();
            this.setState({ customerDualScreenorderList })
        } catch (error) {
        }
    }

    render() {
        let data = this.data();
        return (
            <div>
                <Button style={{margin: '1.5%', width: '97%', backgroundColor: '#abb119', color: 'white'}} onClick={this.addComboSet.bind(this, data)}>Place Order</Button>
                <Grid container spacing={2}>
                    {
                        data.map((c) => {
                            return (
                                <Grid item xs={12}>
                                    <Paper>
                                        <div style={{display: 'flex', width: '100%'}}>
                                            <div style={{width: '20%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                                <Image  src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+c.partno+".jpg"} style={{width: '100px', height: '100px', borderRadius: '5px', margin: '3px'}} />
                                            </div>
                                            <div style={{padding: '5px', width: '65%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                                <b style={{fontSize: '16px'}}>{c.title+'('+c.partno+')'}</b>
                                                <div>{c.tamil_name}</div>
                                                <div>{c.local_name}</div>
                                                <div>{c.description}</div>
                                                <div style={{display: 'flex'}}>
                                                    <b>Unit</b>
                                                    <b style={{marginLeft: '3%'}}>{c.units}</b>
                                                </div>
                                            </div>
                                            <div style={{width: '15%'}}>
                                                <Button style={{backgroundColor: '#abb119', color: 'white', marginTop: '4px'}} 
                                                 onClick={this.addItem.bind(this, c)}>ADD</Button>
                                            </div>
                                        </div>
                                    </Paper>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </div>
        );
    }
}

export default Combos;
